module.exports = __webpack_public_path__ + "img/phone-view-bg.10d28885.png";